import React, { useState } from 'react'
import {
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
} from '@mui/material';
import Carousels from '../../components/Carousel/Carousel'
import Layout from '../../components/Layout/Layout'
import DynamicPager from '../../components/Pager/dynamicPager'
import DiariesCards from '../../components/Diaries/DiariesCards'
import { validateNews } from '../../helpers/validateNews'
import './allDiariesFeed.scss'

const DiariesAll = ({ pageContext }) => {
  
  const {
    diariesFeedConfigPUCC,
    diariesData,
    micrositesData,
    navbar,
    footerData
  } = pageContext

  const microsites = micrositesData.map(microsite => microsite.name);

  const {
    title,
    feedCover,
    diariesFeedMetadata
  } = diariesFeedConfigPUCC

  const objCarousel = {
    visible: true,
    slide: diariesFeedConfigPUCC.feedCover
  }

  const itemsPerPage = 12;
  const [ currentPage, setCurrentPage ] = useState(1);
  
  // Estado para el filtro seleccionado    
  const [ selectedMicrosite, setSelectedMicrosite ] = useState("");
  const [ filteredDiariesAll, setFilteredDiariesAll ] = useState(diariesData);
  const totalPages = Math.ceil(filteredDiariesAll.length / itemsPerPage);
  
  // Función para manejar el cambio de filtro
  const handleFilterChange = (event) => {
    const selectedValue = event.target.value;
    setCurrentPage(1); // Reinicia a la primera página tras el filtro

    if (selectedValue === "Todas") {
      setSelectedMicrosite("");
      setFilteredDiariesAll(diariesData);
    } else {
      setSelectedMicrosite(selectedValue);
      setFilteredDiariesAll(diariesData.filter((diary) =>
        diary.p_ucc_microsites.some((microsite) => microsite.name === selectedValue)
      ));
    }
  };

  // Obtiene los elementos para la página actual
  const paginatedDiaries = filteredDiariesAll.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  return (
    <Layout
      screenData={navbar}
      pageMetadata={diariesFeedMetadata}
      footerData={footerData}
    >
      <section className="all-diaries-feed-container mb-3">
        {objCarousel?.slide &&
          <div className="d-flex flex-column schedule-header-carousel">
            <Carousels carousel={feedCover} keyName={'newsFeed-'} />
          </div>
        }
        <div className={`container my-5 all-diaries-feed`}>
          <div className="px-2 d-flex align-items-center justify-content-between row mb-4">
            <div className="col-12 col-md-6 px-0">
              <div className=" border-bottom">
                <div className="diary-title">
                  {title}
                </div>
              </div>
            </div>

            <FormControl 
              sx={{
                width: '100%',
                my: 1,
                '@media (min-width:768px)': {
                  width: 300,
                },
              }}
            >
              <InputLabel id="single-microsite-label">Área de Conocimiento</InputLabel>
              <Select
                labelId="single-microsite-label"
                id="single-microsite"
                value={selectedMicrosite}
                onChange={handleFilterChange}
                input={<OutlinedInput label="Área de Conocimiento" />}
                sx={{ height: 46, fontSize: 16 }}
              >
                <MenuItem key={`microsite-todas`} value="Todas">Todas</MenuItem>
                {microsites?.map((microsite, i) => (
                  <MenuItem key={`microsite-${microsite}-${i}`} value={microsite}>
                    {microsite}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <div className="diary-container row mb-4">
            {paginatedDiaries < 1 || validateNews(paginatedDiaries) ? (
              <h4 className="mt-5 col">
                No se encontraron eventos en la Agenda de la Escuela de Posgrado UCC
              </h4>
            ) : (
              paginatedDiaries.map((diary) => {
                return (
                  <div key={diary.id} className='diary-card-container col-12 col-sm-6 col-md-4 col-lg-3'>
                    <DiariesCards diary={diary}/>
                  </div>
                )
              })
            )}
          </div>

          <DynamicPager 
            currentPage={currentPage} 
            totalPages={totalPages} 
            itemsPerPage={itemsPerPage} 
            onPageChange={handlePageChange} 
          />
        </div>
      </section>
    </Layout>
  )
}

export default DiariesAll